import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http } from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!localStorage.getItem("oh_token")) { setLoading(false); return; }
    try { const { data } = await http.get("/auth/me"); setUser(data); } catch { localStorage.removeItem("oh_token"); }
    setLoading(false);
  }, []);
  useEffect(() => { load(); }, [load]);

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    localStorage.setItem("oh_token", data.token); setUser(data.user); return data.user;
  };
  const register = async (payload) => {
    const { data } = await http.post("/auth/register", payload);
    localStorage.setItem("oh_token", data.token); setUser(data.user); return data.user;
  };
  const logout = () => { localStorage.removeItem("oh_token"); setUser(null); };
  return <AuthCtx.Provider value={{ user, loading, login, register, logout, reload: load }}>{children}</AuthCtx.Provider>;
}

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);
export function CartProvider({ children }) {
  const [items, setItems] = useState(() => { try { return JSON.parse(localStorage.getItem("oh_cart") || "[]"); } catch { return []; } });
  useEffect(() => { localStorage.setItem("oh_cart", JSON.stringify(items)); }, [items]);
  const add = (p, qty = 1) => setItems((cur) => {
    const i = cur.findIndex((x) => x.product_id === p.id);
    if (i >= 0) { const c = [...cur]; c[i].quantity += qty; return c; }
    return [...cur, { product_id: p.id, name: p.name, slug: p.slug, price: p.price, discount_price: p.discount_price, image: p.images?.[0] || null, quantity: qty }];
  });
  const update = (id, qty) => setItems((c) => c.map((x) => x.product_id === id ? { ...x, quantity: Math.max(1, qty) } : x));
  const remove = (id) => setItems((c) => c.filter((x) => x.product_id !== id));
  const clear = () => setItems([]);
  const count = items.reduce((s, x) => s + x.quantity, 0);
  return <CartCtx.Provider value={{ items, add, update, remove, clear, count }}>{children}</CartCtx.Provider>;
}
